export default "__VITE_ASSET__Dhs3m3Bi__"